import type { PartType } from '../../types';

type UnitFormatter = (params: { number: number }) => string;

type UnitFormatterStrings = {
    UNIT_MOTOR: UnitFormatter;
    UNIT_PROP_AT_MOTOR: UnitFormatter;
    UNIT_PUMP: UnitFormatter;
};

// Only multi-unit parts get a per-unit formatter; the rest fall back to their part
// label. Props are referenced by the motor position they mount on (SR-24).
export const getUnitFormatters = (
    strings: UnitFormatterStrings
): Partial<Record<PartType, UnitFormatter>> => ({
    motor: strings.UNIT_MOTOR,
    propSet: strings.UNIT_PROP_AT_MOTOR,
    pumpSealKit: strings.UNIT_PUMP
});
